import { Component} from '@angular/core';
import { AppSettings } from './settings/app.settings';
import { Settings } from './settings/app.settings.model';
import { InactivityService } from './security/shared/services/inactivity.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  public settings: Settings;
  constructor(public appSettings: AppSettings, private inactivityService: InactivityService) {
      this.settings = this.appSettings.settings;
  }

  ngOnInit() {
      this.inactivityService.initialize();
  }
}
